export default __webpack_public_path__ + "static/media/zawema.bc2ecf88.png";